module.exports = __webpack_public_path__ + "static/media/capa.a4d45a5a.jpg";